// import { useEffect } from "react";
import useNewItemChange from '../../EHR Settings/Templates/OpenTemplate/FormBuilder/hooks/useNewItemChange';

const Date = ({ item, setItem, activeAccordion }) => {
  // const { handleSetDate } = useNewItemChange(setItem, 'Viewer', activeAccordion);

  return (

    <div className="d-flex align-items-center gap-15">
        <p className="text fs-14 ar-light-color w-231px text-end">{item.content}</p>
        <p className="text text-black fs-14">{item.answer || 'N/A'}</p>
    </div>
  );
};

export default Date